(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 4217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(5126);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./comps/pinned-menu.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  top: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    visibility: hidden;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e4da6dd-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e4da6dd-1"
})(_templateObject1(), function(props) {
    return props.fixed ? "fixed" : "absolute";
}, function(props) {
    return props.top;
});
var Phony = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e4da6dd-2"
})(_templateObject2(), breakpoints/* devices.desktop */.Hb.desktop);
var PinnedMenu = function(props) {
    var children = props.children, container = props.container;
    var ref = (0,react.useState)(true), fixed = ref[0], setFixed = ref[1];
    var ref1 = (0,react.useState)(0), top = ref1[0], setTop = ref1[1];
    var ref2 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var onScroll = function() {
            var parent = container.current;
            if (parent === null) return;
            var doc = document.scrollingElement;
            if (doc === null) return;
            var current = ref2.current;
            if (current === null) return;
            var absolutePosition = parent.clientHeight - current.clientHeight;
            var fixedPosition = parent.offsetTop;
            var shouldBeFixed = doc.scrollTop + current.clientHeight < parent.clientHeight;
            if (shouldBeFixed) {
                if (!fixed) setFixed(true);
                if (top !== fixedPosition) setTop(fixedPosition);
            } else {
                if (fixed) setFixed(false);
                if (top !== absolutePosition) setTop(absolutePosition);
            }
        };
        onScroll();
        addEventListener("scroll", onScroll);
        return function() {
            return removeEventListener("scroll", onScroll);
        };
    }, [
        fixed,
        setFixed,
        top,
        setTop,
        container,
        ref2
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Relative, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    fixed: fixed,
                    top: top,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Phony, {
                ref: ref2,
                children: children
            })
        ]
    });
};
/* harmony default export */ var pinned_menu = (PinnedMenu);

;// CONCATENATED MODULE: ./comps/tabs.tsx

function tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  align-items: stretch;\n"
    ]);
    tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n\n  max-width: var(--w-screen);\n  overflow-x: scroll;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    tabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function tabs_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: var(--color-primary-500) !important;\n        "
    ]);
    tabs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: var(--color-blue-900);\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  transition: color 200ms ease-in-out,\n    background-color 300ms ease-in-out;\n\n  align-self: stretch;\n  flex-shrink: 0;\n\n  cursor: pointer;\n\n  ",
        ";\n\n  @media ",
        " {\n    & + & {\n      border-left: unset;\n      border-top: 1px solid var(--color-separator);\n    }\n\n    :hover {\n      background-color: var(--color-blue-200);\n    }\n\n    text-align: left;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-separator);\n  margin: -2px 0 0 0;\n  height: 2px;\n\n  flex-basis: 0;\n  flex-grow: 1;\n  overflow-y: auto;\n\n  border-radius: 4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 6;\n  left: ",
        "px;\n  width: ",
        "px;\n  bottom: 0;\n\n  height: 2px;\n\n  background-color: var(--color-primary-500);\n  border-radius: 2px;\n\n  transition: left 300ms ease-in-out,\n    width 200ms ease-in-out;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n\n  top: ",
        "px;\n  height: ",
        "px;\n  left: 0;\n  width: 2px;\n\n  background-color: var(--color-primary-500);\n  border-radius: 0 2px 2px 0;\n\n  transition: top 300ms ease-in-out,\n    height 200ms ease-in-out;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var MobileColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-0"
})(tabs_templateObject());
var tabs_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-1"
})(tabs_templateObject1(), breakpoints/* devices.desktop */.Hb.desktop);
var Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-2"
})(_templateObject4(), function(props) {
    return props.active ? (0,styled_components_browser_esm/* css */.iv)(tabs_templateObject2()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, breakpoints/* devices.desktop */.Hb.desktop);
var IndicatorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-3"
})(_templateObject5());
var IndicatorBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-4"
})(_templateObject6());
var IndicatorRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-5"
})(_templateObject7(), function(props) {
    return props.left;
}, function(props) {
    return props.width;
});
var IndicatorColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e51c5200-6"
})(_templateObject8(), function(props) {
    return props.top;
}, function(props) {
    return props.height;
});
var Indicator = function(props) {
    var refs = props.refs, active = props.active, parent = props.parent;
    var ref = refs.current && refs.current[active];
    var parentDiv = parent.current;
    if (!ref || !parentDiv) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var rect = ref.getBoundingClientRect();
    var parentRect = parentDiv.getBoundingClientRect();
    var margin = 4;
    var top = rect.y - parentRect.y + margin;
    var height = rect.height - 2 * margin;
    var left = ref.offsetLeft;
    var width = rect.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndicatorContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorColumn, {
                    top: top,
                    height: height
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* TabletOrMobile */.Vi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorRow, {
                    left: left,
                    width: width
                })
            })
        ]
    });
};
var Tabs = function(props) {
    var selected = props.selected, tabs = props.tabs, refs = props.refs, className = props.className;
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var tabRefs = (0,react.useRef)([]);
    var container = (0,react.useRef)(null);
    var getActiveTabIndex = function(windowScroll, elementScroll) {
        if (elementScroll[0] > windowScroll) return 0;
        for(var i in elementScroll)if (elementScroll[i] > windowScroll) return Number(i) - 1;
        return elementScroll.length - 1;
    };
    var checkCurrent = (0,react.useCallback)(function() {
        var currentActive = getActiveTabIndex(window.scrollY, refs.map(function(ref) {
            return ref.offsetTop;
        }));
        var isNotDesktop = !window.matchMedia(breakpoints/* devices.desktop */.Hb.desktop).matches;
        if (isNotDesktop) {
            var currentTab = tabRefs.current[currentActive];
            currentTab === null || currentTab === void 0 ? void 0 : currentTab.scrollIntoView({
                inline: "center"
            });
        }
        if (active !== currentActive) {
            setActive(currentActive);
        }
    }, [
        active,
        setActive,
        refs
    ]);
    (0,react.useEffect)(function() {
        setActive(selected);
        tabRefs.current = tabRefs.current.slice(0, tabs.length);
    }, [
        selected,
        tabs.length
    ]);
    (0,react.useEffect)(function() {
        checkCurrent();
        addEventListener("scroll", checkCurrent);
        return function() {
            return removeEventListener("scroll", checkCurrent);
        };
    }, [
        checkCurrent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileColumn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_Container, {
                ref: container,
                className: className,
                children: [
                    tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                            active: active === index,
                            ref: function(node) {
                                return tabRefs.current && (tabRefs.current[index] = node);
                            },
                            onClick: function() {
                                return window.scrollTo({
                                    top: refs[index].offsetTop + 5,
                                    behavior: "smooth"
                                });
                            },
                            children: tab
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Indicator, {
                        refs: tabRefs,
                        active: active,
                        parent: container
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* TabletOrMobile */.Vi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBackground, {})
            })
        ]
    });
};
/* harmony default export */ var tabs = (Tabs);

// EXTERNAL MODULE: ./comps/cookies.tsx
var cookies = __webpack_require__(1579);
// EXTERNAL MODULE: ./comps/favicon.tsx
var favicon = __webpack_require__(7953);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./pages/careers/index.tsx + 4 modules
var careers = __webpack_require__(5914);
// EXTERNAL MODULE: ./pages/_app.tsx + 2 modules
var _app = __webpack_require__(2673);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/googleapi.tsx
var googleapi = __webpack_require__(9872);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./utils/coins.tsx
var coins = __webpack_require__(279);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(2010);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./sections/editor/editor.tsx
var editor = __webpack_require__(5091);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
;// CONCATENATED MODULE: ./pages/privacy-policy.tsx


function privacy_policy_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: var(--w-screen);\n\n  padding-bottom: 32px;\n\n  @media ",
        " {\n    padding-bottom: 60px;\n  }\n\n  @media ",
        " {\n    padding-bottom: 100px;\n  }\n"
    ]);
    privacy_policy_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n\n  margin: 25px 0 16px 0;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n\n    margin: 25px 0;\n  }\n"
    ]);
    privacy_policy_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n\n  margin: 20px 0 0 0;\n\n  width: calc(var(--w-screen) - 32px);\n\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 1175px;\n    flex-direction: row;\n  }\n"
    ]);
    privacy_policy_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: 4;\n\n  background-color: var(--color-background);\n  top: 48px;\n  left: 0;\n\n  width: var(--w-screen);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  @media ",
        " {\n    top: 70px;\n  }\n\n  @media ",
        " {\n    position: static;\n    padding: 0;\n    width: unset;\n  }\n"
    ]);
    privacy_policy_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n\n  position: relative;\n\n  text-align: center;\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: unset;\n  }\n"
    ]);
    privacy_policy_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  right: -1px;\n\n  width: 30px;\n  height: 60px;\n\n  z-index: 10;\n\n  background: linear-gradient(\n    to right,\n    rgba(255, 0, 0, 0) 0%,\n    var(--color-background) 100%\n  );\n"
    ]);
    privacy_policy_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n\n  gap: 8px;\n\n  padding: 24px;\n  border-radius: 10px;\n\n  background-color: var(--color-background-cell);\n\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 575px;\n  }\n"
    ]);
    privacy_policy_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 20px;\n\n  padding: 20px 16px;\n\n  flex-shrink: 0;\n"
    ]);
    privacy_policy_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function privacy_policy_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: 275px;\n    background-color: var(--color-background-cell);\n    border-radius: 10px;\n    padding: 8px 0;\n  }\n"
    ]);
    privacy_policy_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  z-index: 99;\n\n  bottom: 24px;\n  right: 24px;\n\n  width: 48px;\n  height: 48px;\n\n  display: flex;\n  cursor: pointer;\n\n  border-radius: 100%;\n\n  @media ",
        " {\n    right: calc(50vw - 587px);\n  }\n\n  transition: opacity 300ms ease-in-out,\n    background-color 300ms ease-in-out;\n  opacity: ",
        ";\n\n  pointer-events: ",
        ";\n\n  background-color: var(--color-primary-500);\n\n  &:hover {\n    background-color: var(--color-primary-600);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  justify-self: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: hidden;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  * {\n    line-height: 1.6em;\n  }\n\n  h1,\n  h2,\n  h3 {\n    line-height: 1.2em;\n  }\n\n  h1 {\n    margin-top: 32px;\n    font-size: 40px;\n  }\n\n  h2 {\n    font-size: 28px;\n    text-transform: capitalize;\n  }\n\n  h2,\n  h3 {\n    margin-top: 24px;\n    font-weight: 600;\n  }\n\n  h3 {\n    font-size: 24px;\n  }\n\n  p {\n    font-size: 16px;\n    margin-top: 4px;\n  }\n\n  ol {\n    padding: 8px 16px;\n\n    li {\n      margin-left: 16px;\n      list-style-type: decimal;\n    }\n  }\n\n  ul {\n    padding: 8px 16px;\n\n    li {\n      margin-left: 16px;\n      list-style-type: disc;\n    }\n  }\n\n  a {\n    text-decoration: underline;\n  }\n\n  & > :first-child {\n    margin: 0;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

























var privacy_policy_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-0"
})(privacy_policy_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-de16e6ba-1"
})(privacy_policy_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet);
var DesktopRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-2"
})(privacy_policy_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var FixedMobileMenuAligner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-3"
})(privacy_policy_templateObject3(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var FixedMobileMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-4"
})(privacy_policy_templateObject4(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var ScrollGradient = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-5"
})(privacy_policy_templateObject5());
var SectionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-6"
})(privacy_policy_templateObject6(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var SingleTab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-7"
})(privacy_policy_templateObject7());
var FixedTabs = (0,styled_components_browser_esm/* default */.ZP)(tabs).withConfig({
    componentId: "sc-de16e6ba-8"
})(privacy_policy_templateObject8(), breakpoints/* devices.desktop */.Hb.desktop);
var GoToContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-9"
})(_templateObject9(), function(props) {
    return props.fixed ? "fixed" : "absolute";
}, breakpoints/* devices.desktop */.Hb.desktop, function(props) {
    return props.show ? 1 : 0;
}, function(props) {
    return props.show ? "unset" : "none";
});
var GoToIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-de16e6ba-10"
})(_templateObject10());
var Empty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-11"
})(_templateObject11(), function(props) {
    return props.w;
}, function(props) {
    return props.h;
});
var Styler = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de16e6ba-12"
})(_templateObject12());
var PrivacyPolicy = function() {
    var t = (0,esm/* useTranslation */.$G)("page-policy").t;
    var ref = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)([]), tags = ref1[0], setTags = ref1[1];
    var ref2 = (0,react.useState)(false), showGoTo = ref2[0], setShowGoTo = ref2[1];
    var ref3 = (0,react.useState)(true), fixed = ref3[0], setFixed = ref3[1];
    var goToShowHandler = (0,react.useCallback)(function() {
        var ref;
        var body = document.body, html = document.documentElement;
        var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        var currentGoTo = height * 0.3 < window.scrollY;
        if (currentGoTo !== showGoTo) setShowGoTo(currentGoTo);
        var maxFixedScroll = window.innerHeight;
        var containerHeight = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (!containerHeight) return;
        var gotoFixed = containerHeight - window.scrollY >= maxFixedScroll;
        if (gotoFixed !== fixed) setFixed(gotoFixed);
    }, [
        fixed,
        showGoTo
    ]);
    (0,react.useEffect)(function() {
        addEventListener("scroll", goToShowHandler);
        goToShowHandler();
        return function() {
            return removeEventListener("scroll", goToShowHandler);
        };
    }, [
        goToShowHandler
    ]);
    (0,react.useEffect)(function() {
        var section = ref.current;
        if (!section) return;
        var currentTags = (0,_to_consumable_array/* default */.Z)(section.getElementsByTagName("h2"));
        currentTags.forEach(function(current) {
            var preElement = current.previousElementSibling;
            if (!preElement) return;
            var codeElement = preElement.querySelector("code");
            if (!codeElement) return;
            var label = codeElement.innerHTML;
            current.setAttribute("data-label", label);
            preElement.hidden = true;
        });
        setTags(currentTags);
    }, []);
    var scrollToTop = function() {
        return window.scrollTo({
            top: 0
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(privacy_policy_Container, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                        title: t("common:txt_policy_title"),
                        description: t("common:txt_policy_description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {
                        isStatic: true,
                        isSolid: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("common:txt_terms_and_privacy")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                            height: 120
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Tablet */.YD, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                            height: 140
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedMobileMenuAligner, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FixedMobileMenu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Tablet */.YD, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollGradient, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* TabletOrMobile */.Vi, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                children: t("common:txt_terms_and_privacy")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pinned_menu, {
                                            container: ref,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedTabs, {
                                                selected: 0,
                                                tabs: tags.map(function(tag, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleTab, {
                                                        children: tag.getAttribute("data-label") ? tag.getAttribute("data-label") : tag.innerText
                                                    }, index);
                                                }),
                                                refs: tags
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionsContainer, {
                                ref: ref,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Styler, {
                                    dangerouslySetInnerHTML: {
                                        __html: t("page-policy:page")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {
                                    w: 275,
                                    h: 10
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToContainer, {
                        onClick: scrollToTop,
                        show: showGoTo,
                        fixed: fixed,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToIcon, {
                            src: (0,cdn/* assetUrl */.p)("/icons/goto-top.svg"),
                            alt: "goto top icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* WrappedFooter */.M, {})
        ]
    });
};
PrivacyPolicy.Layout = function Layout(props) {
    var children = props.children, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* ThemeProvider */.f, {
        attribute: "class",
        forcedTheme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(careers.GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
                client: _app.queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_auth/* ClientSideAuthProvider */.s5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification/* NotificationProvider */.J, {
                        timeout: 3000,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                            scriptProps: {
                                async: true
                            },
                            reCaptchaKey: "6LelseIjAAAAAEmIkD3assuAQxcbF9vd0zbE-jMG",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(coins/* CoinsProvider */._k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(adjust/* AdjustProvider */.xF, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(favicon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cookies/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorParamsProviders */.i9, {
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adjust/* UsePageViewEvent */.rs, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(googleapi/* GoogleOneTap */.K, {})
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var privacy_policy = (PrivacyPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5914,9774,2888,179], function() { return __webpack_exec__(4217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);